import { $host } from ".";

// 📩 Contact form mail
export const sendContactMail = async (formData) => {
    try {
        const { data } = await $host.post('api/mail', formData);
        return data;
    } catch (error) {
        console.error("Error sending contact mail:", error);
        throw error;
    }
};

// 📅 Booking mail
export const sendBookingMail = async (formData) => {
    try {
        const { data } = await $host.post('api/mail/booking', formData);
        return data;
    } catch (error) {
        console.error("Error sending booking mail:", error);
        throw error;
    }
};
